import { defineChain } from 'viem'
import { avalanche } from '@coti-io/coti-wallet-plugin'
import {
  AVALANCHE_FUJI_CHAIN_ID,
  COTI_MAINNET_CHAIN_ID,
  COTI_TESTNET_CHAIN_ID,
  ETHEREUM_MAINNET_CHAIN_ID,
  SEPOLIA_CHAIN_ID,
  getChainConfig,
} from '@/chains'

/** Build a local viem chain from the vendored {@link CHAIN_CONFIGS} (single source of truth). */
const chainFromPlugin = (chainId: number) => {
  const config = getChainConfig(chainId)
  if (!config) {
    throw new Error(`Chain config missing from the vendored chain registry for chainId ${chainId}`)
  }

  const httpRpcUrls = config.rpcFallbackUrls?.length
    ? [config.rpcUrl, ...config.rpcFallbackUrls]
    : [config.rpcUrl]

  return defineChain({
    id: config.id,
    name: config.name,
    nativeCurrency: { ...config.walletNetwork.nativeCurrency },
    rpcUrls: { default: { http: httpRpcUrls } },
    blockExplorers: {
      default: {
        name: config.explorerBaseUrl.includes('cotiscan')
          ? 'CotiScan'
          : config.explorerBaseUrl.includes('etherscan') || config.explorerBaseUrl.includes('snowscan')
            ? 'Explorer'
            : 'Explorer',
        url: config.explorerBaseUrl,
      },
    },
  })
}

export const cotiTestnet = chainFromPlugin(COTI_TESTNET_CHAIN_ID)
export const cotiMainnet = chainFromPlugin(COTI_MAINNET_CHAIN_ID)
export const sepolia = chainFromPlugin(SEPOLIA_CHAIN_ID)
export const avalancheFuji = chainFromPlugin(AVALANCHE_FUJI_CHAIN_ID)
export const ethereumMainnet = chainFromPlugin(ETHEREUM_MAINNET_CHAIN_ID)
export { avalanche }
